var map = {
	"./ALC-logo.svg": "c758",
	"./ALCP-logo.svg": "6010",
	"./BNB-logo.svg": "1fb4",
	"./BTC-logo.svg": "3b15",
	"./CBT-logo.svg": "720c",
	"./CCC-logo.png": "b5b0",
	"./CCC-logo.svg": "781d",
	"./CCS-logo.svg": "cc86",
	"./DISE-logo.svg": "7b31",
	"./ETH-logo.svg": "4ff2",
	"./EUR-logo.svg": "5fb5",
	"./HLM-logo.svg": "0f95",
	"./LSS-logo.svg": "a008",
	"./MATIC-logo.svg": "5df5",
	"./NKCLC-logo.png": "c28e",
	"./NKCLC-logo.svg": "b257",
	"./NKCLM-logo.png": "a276",
	"./NKCLM-logo.svg": "0420",
	"./PCC-logo.svg": "0a2e",
	"./PLI-logo.svg": "d2ee",
	"./PLP-logo.svg": "f95d",
	"./PRTG-logo.svg": "03d1",
	"./SOLANA-logo.png": "5d25",
	"./SOLANA-logo.svg": "276c",
	"./STAIKA-logo.png": "4e2a",
	"./STAIKA-logo.svg": "6a12",
	"./TRX-logo.svg": "8b50",
	"./UBP-logo.svg": "2ba1",
	"./UMC-logo.svg": "3f61",
	"./UMCP-logo.svg": "2c59",
	"./USDT-TRC-logo.svg": "fb18",
	"./USDT-logo.svg": "f586",
	"./W3P-logo.svg": "4ca2",
	"./check.svg": "4a24",
	"./custom-mark.svg": "7bd2",
	"./logo-ALC-P.svg.svg": "91ef",
	"./logo-ALC-logo-tmp.svg": "c1ae",
	"./logo-ALC.svg": "89da",
	"./logo-ALCP-tmp.svg": "d926",
	"./logo-ALCP.svg": "252b",
	"./logo-BNB-tmp.svg": "b486",
	"./logo-BNB.svg": "3939",
	"./logo-BTC-tmp.svg": "c330",
	"./logo-DISE-tmp.svg": "caa1",
	"./logo-ETH-tmp.svg": "7d94",
	"./logo-EUR-tmp.svg": "eb24",
	"./logo-HLM.svg": "41f7",
	"./logo-MATIC.svg": "224b",
	"./logo-PLI-tmp.svg": "add9",
	"./logo-PLP-tmp.svg": "2c99",
	"./logo-PRTG-tmp.svg": "702b",
	"./logo-PRTG.svg": "9acb",
	"./logo-SOLANA-tmp.svg": "d633",
	"./logo-SOLANA.svg": "23c3",
	"./logo-SSP-tmp.svg": "85f9",
	"./logo-STAIKA-tmp.svg": "fcd6",
	"./logo-STAIKA.svg": "e7a4",
	"./logo-TRX.svg": "8ed2",
	"./logo-UMC-tmp.svg": "dd7e",
	"./logo-UMC.svg": "0913",
	"./logo-UMCP-tmp.svg": "3035",
	"./logo-UMCP.svg": "c7fa",
	"./logo-USDT-TRC-tmp.svg": "3f66",
	"./logo-USDT-tmp.svg": "4873",
	"./logo-W3P-tmp.svg": "6332",
	"./logo-W3P.svg": "f250",
	"./logo.svg": "a5f7",
	"./logo_black.svg": "f0f8",
	"./logo_image.svg": "37b9",
	"./paycam-logo.svg": "e918",
	"./paypal.svg": "e66d",
	"./pw-logo-color.svg": "4287",
	"./pw-logo-white.svg": "77ec",
	"./qr-code.svg": "101b",
	"./qr-sample.svg": "399f3",
	"./swap.svg": "495f",
	"./ub-logo.svg": "b7ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";